<script setup lang="ts">

import { MarketplaceFilterType } from "@domain/Marketplace";
import type { IMarketplaceViewModel } from '@app/MyMarketplace/Types/IMarketplaceViewModel';

type Props = { isSearching: boolean }
const model = defineModel<IMarketplaceViewModel>( { required: true })
const { isSearching } = defineProps<Props>();

</script>

<template>

    <div class="absolute right-0 pointer-events-none
                transition-all duration-300 opacity-0 
                px-4 3xl:px-6 translate-x-4
                flex items-center gap-2 3xl:gap-4"
         :class="{
            '!opacity-100 !pointer-events-auto duration-450 !translate-x-0 z-10 ease-in': isSearching || model.activeGroup != null
         }">

        <IconButton name="filter" 
                    class="bg-white/10 text-2xl 3xl:!w-14 3xl:!h-14"
                    :class="
                    {
                        '!bg-secondary-500/60 text-secondary-200': model.filterType != MarketplaceFilterType.All 
                    }"
                    @click="model.isFilterOpen = !model.isFilterOpen">
        </IconButton>
        
    </div>

</template>